import Application from "./Application";
import common from "./common";
import PreloaderScene from "./scenes/PreloaderScene";

export default class Main {
    /**
     * @param {number} [width=1024]
     * @param {number} [height=768]
     */
    constructor(width = 1024, height = 768) {
        this._width = width;
        this._height = height;
        this._app = null;
        this._preloader = null;
        this._printLoadProgress = false;
    }

    init() {
        P3.assets.audioFileTypes = ["mp3"];
        P3.settings.WARN_TEXTURE_DIVISIBLE_BY_2 = false;
        P3.audio.preloadAudio = true;
        P3.input.refocus = false;
        
        PIXI.settings.RETINA_PREFIX = /_(?=[^_]*$)(.+)x/;
        PIXI.settings.MIPMAP_TEXTURES = false;
        PIXI.settings.STRICT_TEXTURE_CACHE = true;

        PIXI.settings.SPRITE_MAX_TEXTURES = 8;

        //handle app being minimised
        document.addEventListener("pause", () => this.onPause(), false);
        document.addEventListener("resume", () => this.onResume(), false);

        this._paused = false;
        this._mute = false;
     
        document.addEventListener('visibilitychange', () => {
            if (document.hidden) 
            {
                if (P3.audio.music) {
                    P3.audio.music.pause();
                }
                this._paused = true;
                window.blur();
            } 
            else 
            {
                if (P3.audio.music) {
                    P3.audio.music.play();
                }
                this._paused = false;
                window.focus();
            }
        });

        typeof TweenMax !== "undefined" && (TweenMax.defaultOverwrite = "none");

        const options = {
            width: this._width,
            height: this._height,
            holderId: "game",
            portrait: false,
            rotateImageUrl: "./assets/images/ui_rotate_device_1x.jpg",
            rotateImageColor: "#000000",
            aspectRatioFillHeight: true
        };

        const view = new P3.View(options);
        view.signals.ready.once(canvas => {
            const options = {};
            options.view = canvas;
            options.backgroundAlpha = false;
            options.antialias = false;
            options.preserveDrawingBuffer = false;
            options.resolution = 1;
            options.width = this._width;
            options.height = this._height;

            const stage = new PIXI.Container();
            common.stage = stage;

            P3.input.init(stage, canvas);

            const renderer = PIXI.autoDetectRenderer(options);

            renderer.backgroundColor = 0x000000;
            common.renderer = renderer;

            common.stage.addChild(P3.scene.view);

            const transitions = new PIXI.Container();
            common.stage.addChild(transitions);
            common.transitions = transitions;

            // deprecated
            //window.lasttweentime = 0;
            //window.tweendt = 0;

            PIXI.Ticker.shared.add((deltaTime) => {
                window.deltaTime = deltaTime / PIXI.settings.TARGET_FPMS / 1000;

                // deprecated
                //const currentTime = P3.utils.TWEEN.now();
                //window.tweendt = currentTime - window.lasttweentime;
                //window.lasttweentime = currentTime;

                if (!this._paused) {
                    P3.scene.update(window.deltaTime);
                    P3.input.update();

                    P3.utils.TWEEN.update();// comment this line out if you are using TweenMax

                    renderer.render(stage);
                }
            });

            this.loadPreAssets();

        }, this);

        view.signals.resize.add(this.onCanvasResize, this);
        common.view = view;

        this.loadConfig(function () {
            view.init()
        }, this);    // we load the config before we do anything
    }

    loadConfig(callback, scope) {
        scope = scope || window;
        P3.assets.addFiles([{name: "config", url: "config" + ".json"}], "./");
        P3.assets.signals.complete.once(function () {
            common.config = P3.assets.json("config");
            common.config.language = window.__language || 'en';
            callback && callback.call(scope);
        }, this);
        P3.assets.load();
    }

    loadPreAssets() {
        const files = [
            {name: "characters", url: "data/characters" + ".json"},
            {name: "cn_preloader_1x", url: "images/cn_preloader_1x" + ".json"},
            {name: "cn_preloader", url: "images/cn_preloader" + ".jpg"},
            {name: "bg_main", url: "images/bg_main" + ".jpg"},
            {name: "preloader_pencil", url: "images/preloader_pencil" + ".png"},

        ];
        if (files.length) {
            P3.assets.addFiles(files, "./assets/");
            P3.assets.signals.complete.once(this.loadAssets, this);
            P3.assets.load();
        } else {
            this.loadAssets();
        }
    }

    loadAssets() {
        const files = [
            // texture sheet

            //logo
            {name: 'game_logo', url: 'localization/show_logo_en' + '.png'},
            //{name: 'game_logo', url: 'localization/show_logo_'+common.config.language + '.png'},

            //bgs
            {name: "bg_ivandoe_1", url: "images/bg_ivandoe_1" + ".jpg"},
            {name: "bg_ivandoe_2", url: "images/bg_ivandoe_2" + ".jpg"},
            {name: "bg_ivandoe_3", url: "images/bg_ivandoe_3" + ".jpg"},

            //new button
            {name: 'new', url: 'localization/new/new_'+common.config.language + '.png'},
            {name: "ui_1x", url: "images/ui_1x" + ".json"},

            // data
            {name: "strings", url: "data/strings" + ".json"},
            {name: "ip", url: "data/ip" + ".json"},

            // audio
            {name: 'music_splash_loop_00', url: 'audio/music/music_splash_loop_00.mp4'},
            {name: 'music_drawing_loop_00', url: 'audio/music/music_drawing_loop_00' + P3.assets.audioFileExt},
            {name: 'music_complete_sting_02', url: 'audio/music/music_complete_sting_02' + P3.assets.audioFileExt},
            {name: 'music_complete_sting_01', url: 'audio/music/music_complete_sting_01' + P3.assets.audioFileExt},
            {name: 'music_complete_sting_00', url: 'audio/music/music_complete_sting_00' + P3.assets.audioFileExt},
            {name: 'sfx_btn_ui_commit_00', url: 'audio/sfx/sfx_btn_ui_commit_00' + P3.assets.audioFileExt},
            {name: 'sfx_btn_ui_next_drawing_00', url: 'audio/sfx/sfx_btn_ui_next_drawing_00' + P3.assets.audioFileExt},
            {name: 'sfx_btn_ui_prev_drawing_00', url: 'audio/sfx/sfx_btn_ui_prev_drawing_00' + P3.assets.audioFileExt},
            {name: 'sfx_btn_ui_print_00', url: 'audio/sfx/sfx_btn_ui_print_00' + P3.assets.audioFileExt},
            {name: 'sfx_btn_ui_repeatstep_00', url: 'audio/sfx/sfx_btn_ui_repeatstep_00' + P3.assets.audioFileExt},
            {name: 'sfx_btn_ui_trash_00', url: 'audio/sfx/sfx_btn_ui_trash_00' + P3.assets.audioFileExt},
            {name: 'sfx_drawing_fill_00', url: 'audio/sfx/sfx_drawing_fill_00' + P3.assets.audioFileExt},
            {name: 'sfx_drawing_loop_00', url: 'audio/sfx/sfx_drawing_loop_00' + P3.assets.audioFileExt},
            {name: 'sfx_click', url: 'audio/sfx/sfx_click' + P3.assets.audioFileExt},
            {name: 'sfx_camera_flash_00', url: 'audio/sfx/sfx_camera_flash_00' + P3.assets.audioFileExt},
        ];

        //Load character files
        const json = P3.assets.json("characters");
        for (let i=0; i<json.length; i++) {
            const character = json[i];
            files.push({name: 'character_'+character.name, url: 'characters/'+character.folderName+'/character.json'});
            files.push({name: 'character_'+character.name+'_pencil', url: 'characters/'+character.folderName+'/paths.json'});
            files.push({name: 'character_'+character.name+'_data', url: 'characters/'+character.folderName+'/data/character.json'});

            if (character.hasProp) {
                files.push({name: 'character_'+character.name+'_prop', url: 'characters/'+character.folderName+'/prop.json'});
            }
            /*
            {name: 'character', url: 'spine/character' + '.json'},
            {name: 'character_pencil', url: 'spine/paths' + '.json'},
            {name: 'character_data', url: 'data/character' + '.json'},
             */
        }

        if (files.length) {
            this._preloader = new PreloaderScene();
            P3.scene.show(this._preloader);

            P3.assets.addFiles(files, "./assets/");
            P3.assets.signals.progress.add(this.onLoadingProgress, this);
            P3.assets.signals.complete.once(this.onLoadingCompleted, this);
            P3.assets.load();
        } else {
            this.start();
        }
    }

    start() {
        this._app = new Application();
        this._app.init();
    }

    onLoadingProgress(event) {
        this._preloader && (this._preloader.loaded = event.progress / 100);
        this._printLoadProgress && console.log("loading:", Math.floor(event.progress));
    }

    onLoadingCompleted() {
        common.strings = P3.assets.json("strings");
        this._preloader && (this._preloader.loaded = 1);
        setTimeout(() => this.start(), 1240);
    }

    onCanvasResize(correct) {
        if (correct) {
            common.renderer.resize(P3.View.width, P3.View.height);
            if (P3.scene) {
                P3.scene.resize();

                for (let i = 0; i < common.transitions.children.length; ++i) {
                    const transition = common.transitions.children[i];
                    transition.resize && transition.resize();
                }
            }
        }
    }

    //app pause, when app is put in background
    onPause() {
        // the page has been hidden
        this._mute = P3.audio.isMute;
        P3.audio.mute(true);
        this._paused = true;
        window.blur();
    }

    //app returns to focus
    onResume() {
        // the page has become visible
        P3.audio.mute(this._mute);
        this._paused = false;
        window.focus();
    }
}
